module.exports = __webpack_public_path__ + "static/media/ic_insurance.839010e5.png";